/**
 * Example inputs for the two conversion flows.
 * Files live in public/examples/.
 * - EXAMPLE_IMAGES feed the image flow (pixelate → mosaic).
 * - EXAMPLE_MODELS are Wavefront .obj meshes fed to the 3D-model pipeline.
 */
export interface ExampleImage {
  id: string;
  label: string;
  path: string;
}

export interface ExampleModel {
  id: string;
  label: string;
  path: string;
}

export const EXAMPLE_IMAGES: ExampleImage[] = [
  { id: "painting1", label: "Example 1", path: "/examples/painting1.webp" },
  { id: "painting2", label: "Example 2", path: "/examples/painting2.webp" },
  { id: "painting3", label: "Example 3", path: "/examples/painting3.jpg" },
  { id: "painting4", label: "Example 4", path: "/examples/painting4.webp" },
  { id: "painting6", label: "Example 5", path: "/examples/painting6.jpeg" },
  { id: "painting7", label: "Example 6", path: "/examples/painting7.jpg" },
];

export const EXAMPLE_MODELS: ExampleModel[] = [
  { id: "diamond", label: "Diamond", path: "/examples/diamond.obj" },
  { id: "pyramid", label: "Pyramid", path: "/examples/pyramid.obj" },
  { id: "house", label: "House", path: "/examples/house.obj" },
  { id: "tree", label: "Tree", path: "/examples/tree.obj" },
  // Complex organic models — assimp test models, BSD license
  // (github.com/assimp/assimp); attribution comment in each file header
  { id: "wuson", label: "Lion Statue", path: "/examples/wuson.obj" },
  { id: "spider", label: "Spider", path: "/examples/spider.obj" },
  // Kenney asset packs (kenney.nl) — CC0 1.0; attribution comment in each
  // file header. Closed, low-poly solids — they voxelize into solid builds.
  // (Kenney reuses one humanoid mesh across the character packs, so only
  // one character is shipped.)
  { id: "knight", label: "Knight", path: "/examples/knight.obj" },
  { id: "spaceship", label: "Spaceship", path: "/examples/spaceship.obj" },
  { id: "meteor", label: "Meteor", path: "/examples/meteor.obj" },
  // McGuire Computer Graphics Archive (casual-effects.com/data) — public
  // domain; attribution comment in the file header
  { id: "globe", label: "Globe", path: "/examples/globe.obj" },
  // Scenes: several models merged onto one .obj, placed on a grid
  { id: "village", label: "Village", path: "/examples/village.obj" },
  { id: "menagerie", label: "Menagerie", path: "/examples/menagerie.obj" },
];
